module.exports = __webpack_public_path__ + "static/media/transaction_history.7ec73d13.svg";